"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccordionItem", {
  enumerable: true,
  get: function get() {
    return _AccordionItem["default"];
  }
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _nanoid = require("nanoid");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _Accordion = _interopRequireDefault(require("./Accordion.context"));

var _Accordion2 = require("./Accordion.styles");

var _AccordionItem = _interopRequireDefault(require("./AccordionItem/AccordionItem.index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Accordion = function Accordion(_ref) {
  var className = _ref.className,
      behavior = _ref.behavior,
      children = _ref.children,
      type = _ref.type;
  var behaviorCheck = Array.isArray(children) ? behavior : 'checkbox';
  var accordionRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      radioCheckedId = _useState2[0],
      setRadioCheckedId = _useState2[1];

  var name = (0, _react.useMemo)(function () {
    return behaviorCheck === 'radio' ? (0, _nanoid.nanoid)() : undefined;
  }, [behaviorCheck]);

  var closeRemainingRadioButton = function closeRemainingRadioButton() {
    var accordion = accordionRef.current;
    accordion.querySelectorAll('input[type=radio]:checked').forEach(function (obj) {
      var radioButton = obj;
      radioButton.checked = false;
    });
    setRadioCheckedId(0);
  };

  return /*#__PURE__*/_react["default"].createElement(_Accordion["default"].Provider, {
    value: {
      behavior: behaviorCheck,
      closeRemainingRadioButton: closeRemainingRadioButton,
      name: name,
      radioCheckedId: radioCheckedId,
      type: type,
      setRadioCheckedId: setRadioCheckedId
    }
  }, /*#__PURE__*/_react["default"].createElement(_Accordion2.StyledAccordion, {
    ref: accordionRef,
    className: className
  }, children));
};

Accordion.AccordionItem = _AccordionItem["default"];
Accordion.defaultProps = {
  behavior: 'radio',
  type: 'normal',
  className: null
};
var accordionItem = (0, _propTypes.shape)({
  type: (0, _propTypes.oneOf)([_AccordionItem["default"]])
});
Accordion.propTypes = {
  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** Defines behavior of the accordion.<br/>
   * If "radio", only one accordion item will be visible at a time.<br/>
   * If "checkbox", multiple accordion items can be visible simultaneously. */
  behavior: (0, _propTypes.oneOf)(['checkbox', 'radio']),

  /** Accordion Items to be rendered */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(accordionItem), accordionItem]).isRequired,

  /** Defines the title typography */
  type: (0, _propTypes.oneOf)(['heading', 'normal'])
};
Accordion.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Accordion",
  "props": {
    "behavior": {
      "defaultValue": {
        "value": "'radio'",
        "computed": false
      },
      "description": "Defines behavior of the accordion.<br/>\r\nIf \"radio\", only one accordion item will be visible at a time.<br/>\r\nIf \"checkbox\", multiple accordion items can be visible simultaneously.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'checkbox'",
          "computed": false
        }, {
          "value": "'radio'",
          "computed": false
        }]
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'normal'",
        "computed": false
      },
      "description": "Defines the title typography",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'heading'",
          "computed": false
        }, {
          "value": "'normal'",
          "computed": false
        }]
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "Accordion Items to be rendered",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "custom",
            "raw": "accordionItem"
          }
        }, {
          "name": "custom",
          "raw": "accordionItem"
        }]
      },
      "required": true
    }
  }
};
var _default = Accordion;
exports["default"] = _default;